/* eslint-disable import/first */
// import 'buefy/dist/buefy.css';
// import 'bulma-o-steps/bulma-steps.sass';
import Buefy from 'buefy';
import Vue from 'vue';
/** 
 * * 추후 해당(Vue2Editor) 에디터 제거 가능성 있음.
 */
import Vue2Editor from "vue2-editor";
/** 
 * * 추후 해당(Vue2Editor -> CkEditor) 에디터 교체 가능성 있음.
 */
import CKEditor from '@ckeditor/ckeditor5-vue2';

import VueCookie from 'vue-cookie';
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment';
import VueMomentJS from 'vue-momentjs';
/**
 * HTTP Connection
 */
import axios from 'axios';
// eslint-disable-next-line no-unused-vars, import/no-extraneous-dependencies
import * as URI from "uri-js";

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import VueSignaturePad from 'vue-signature-pad';
import $ from 'jquery';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/element-variables.scss';
import locale from 'element-ui/lib/locale/lang/ko'
import VueQuagga from "vue-quaggajs";
//commons local css
import './assets/common.scss';
//import babelPolyfill from 'babel-polyfill'


/**
 * Lodings UI
 * 
 */
// Import component
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
/**
 * ag-grid License Manage
 * init
 */
import {LicenseManager} from "ag-grid-enterprise";

LicenseManager.setLicenseKey("CompanyName=iljin cns,LicensedApplication=ijcns,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-013981,ExpiryDate=3_March_2022_[v2]_MTY0NjI2NTYwMDAwMA==79ca3f5c5621088302aec8ce6faf7207");

moment.locale('ko')

/**
 * RESTful API Transaction
 */
var resource = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 1800000,
  headers : {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json',
  }
});

Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.prototype.$http.defaults.timeout = 1800000;
Vue.prototype.$http.defaults.headers = {
  'Access-Control-Allow-Origin': '*',
  'Content-type': 'application/json',
};

/**
 * * Buefy 프로토타입 생성자 세팅 옵션 공식문서
 * @link https://buefy.org/documentation/constructor-options
 * */
Vue.use(Buefy, {
  //Default modal canCancel attribute	Boolean, Array : false, escape, x, outside, button
  //제어할 수 있는 부분을 선언 버튼 과 x
  defaultModalCanCancel: ['button', 'x'],
});
Vue.use(VueSweetalert2);
Vue.use(VueCookie);
Vue.use(VueMomentJS, moment);
Vue.use(Vue2Editor);
Vue.use(CKEditor);
Vue.use(VueSignaturePad);
Vue.use(ElementUI, {locale});
Vue.use(VueQuagga);
Vue.use(Loading);
/**
 * Regist global components
 */
import {AgGridVue} from 'ag-grid-vue';
import {TheMask} from 'vue-the-mask';

Vue.component('AgGridVue', AgGridVue)
Vue.component('TheMask', TheMask)

/**
 * * CodeService
 */
import CodeService from "@/libs/CodeService";

Vue.prototype.$code = new CodeService(resource);

/**
 * * BoardService
 */
import BoardService from "@/libs/BoardService";

Vue.prototype.$board = new BoardService(resource);


/**
 * * MenuService
 */
import MenuService from "@/libs/MenuService";

Vue.prototype.$menu = new MenuService(resource, store, router);

/**
 * * 간단한 모바일 체크
 */
import Device from "@/libs/Device";

Vue.prototype.$device = new Device(window.navigator.userAgent);

/**
 * * Swiper js
 */
import SwiperPub from '@/libs/pub';

Vue.prototype.$swiper = new SwiperPub();
/**
 * Integrate NumeralJS
 */
const numeral = require('numeral')

Vue.prototype.$numeral = numeral
/// Integrate NumeralJS

// filters
Vue.filter('number', (value) => value ? new Intl.NumberFormat().format(value.toString().replace(/\D/g, "") || 0) : value);
Vue.prototype.$filters = Vue.options.filters;

//Event bus
Vue.prototype.$bus = new Vue()

// Debug?
Vue.prototype.debug = (process.env.NODE_ENV === 'development')

// import { _url as url } from './libs/join';

new Vue({
  router,
  store,
  i18n,
  created() {
    
    console.log(process.env.NODE_ENV);
    /**
     * HTTP Request Interceptor
     */
    this.$http.interceptors.request.use((config) => {

      /**
       * check current session alive.
       * using by browser cookie(life-time: session)
       */
      if(this.$cookie.get('sessionAlive') === null) {
        //console.log(this.$cookie.get('sessionAlive'));
        this.$store.commit('logout');
        this.$cookie.delete('loginInfo');
      }
      /*device-width check*/
      var mql = window.matchMedia("screen and (max-width: 820px)"); 
      if (mql.matches) { 
        $(".lnb").addClass("minimized");
        $(".header > .logo").addClass("mini");
        $(".header .logo > a > img.logo-big").css("display", "none");
        $(".header .logo > a > img.logo-mini").css("display", "none");
      }

      /**
       * Session auto-injection
       */
      if (this.$store && this.$store.state && this.$store.state.loginInfo) {
        var session = this.$store.state.loginInfo
        /**
         * compCd가 없는 경우, 자동으로 Injection
         */
        switch (String(config.method || '').toLowerCase()) {
          case 'get':
          case 'delete':
            if (config.params !== undefined && typeof config.params === 'object' && !config.params.compCd) {
              config.params.compCd = session.compCd
            }
            break
          case 'post':
          case 'put':
            if (config.data !== undefined && typeof config.data === 'object' && !config.data.compCd) {
              config.data.compCd = session.compCd
            }
            break
        }
      }
      return config
    })

    this.$http.interceptors.response.use(response => {
      
      return response
    }, error => {
      
      if (error.response && error.response.data && error.response.data.message) {
        
        if(error.response.data.status===403){
          this.$router.push({path: `/login`}).catch(()=>{});
        }else{
          if(error.response.data.status === 500 && error.response.data.message.indexOf('V_COMPANY_ID') > 0) {
            this.$router.push({path: `/login`}).catch(()=>{});
          } else {
            this.$swal({
              type: 'error',
              text: error.response.data.message
            })

          }
        }
      }
      return Promise.reject(error)
    })
  },
  render: h => h(App),
}).$mount('#app');
